$(document).ready(function(){

    var header = $('.s-header');
    var burger = $('.c-burger');

    burger.click(function(evt){
        evt.preventDefault();
        header.toggleClass('s-header--open');
        if (header.hasClass('s-header--open')) {
            $('body').css('overflow', 'hidden');
            // $(window).scrollTop(0);
            // $(window).on('scrollend', function(){
            //     $('body').css('overflow', 'hidden');
            //     $(window).off('scrollend');
            // });
        } else {
            $('body').css('overflow', 'auto');
        }
    });

});